<template>
  <b-overlay :show="loading">
    <b-row>
      <b-col md="6" sm="12">
        <validation-observer ref="registerForm" #default="{ invalid }">
          <b-form @submit.prevent="updateMemberProfile">
            <b-form-group label="Member Type" label-for="member_type_id">
              <template #label>
                <span>Member Type<span style="color: tomato">*</span></span>
              </template>

              <validation-provider #default="{ errors }" name="member_type_id">
                <v-select
                  id="member_type_id"
                  v-model="member_profile.member_type_id"
                  :loading="loading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="memberTypeOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="Member Title" label-for="member_title_id">
              <template #label>
                <span>Member Title<span style="color: tomato">*</span></span>
              </template>

              <validation-provider #default="{ errors }" name="member_title_id">
                <v-select
                  id="member_title_id"
                  v-model="member_profile.member_title_id"
                  :loading="loading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="memberTitleOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="Member Designation"
              label-for="member_designation_id"
            >
              <template #label>
                <span>Member Designation<span style="color: tomato">*</span></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="member_designation_id"
              >
                <v-select
                  id="member_designation_id"
                  v-model="member_profile.member_designation_id"
                  :loading="loading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="memberDesignationOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              v-if="isCopStaff || isCopMinister"
              label="Departmentss"
              label-for="department"
            >
              <template #label>
                <span>Departments<span style="color: tomato">*</span></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="department"
              >
                <v-select
                  id="department"
                  v-model="member_profile.department_id"
                  :loading="loading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="departmentOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              placeholder="Date of birth"
              label-for="Date_of_birth"
              class="mb-2"
            >
              <template #label>
                <span>Date of birth<sup style="color: tomato">*</sup></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="Date of birth"
                :rules="{
                  required: true,
                }"
              >
                <cleave
                  v-model="member_profile.date_of_birth"
                  :raw="false"
                  :options="cleaveDateOptions"
                  autocomplete="off"
                  class="form-control"
                  name="date of birth"
                  placeholder="YYYY-MM-DD"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="Gender" label-for="gender">
              <template #label>
                <span>Gender<span style="color: tomato">*</span></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="gender"
                rules="required"
              >
                <v-select
                  id="gender"
                  v-model="member_profile.gender"
                  :loading="loading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="genderOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              v-if="isCopMinister"
              label="Minister Id"
              label-for="minister_id"
            >
              <template #label>
                <span>Minister Id<span style="color: tomato">*</span></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="minister_id"
                rules="required"
              >
                <input
                  id="minister_id"
                  v-model="member_profile.minister_id"
                  placeholder="Enter Id Here"
                  class="form-control"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="Country" label-for="country">
              <template #label>
                <span>Country<span style="color: tomato">*</span></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="country"
                rules="required"
              >
                <v-select
                  id="country"
                  v-model="member_profile.country"
                  :loading="loading"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="countryOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              v-if="isCopMinister"
              label="year_called_into_ministry"
              label-for="year_called_into_ministry"
            >
              <template #label>
                <span>Year Called Into Ministry<span style="color: tomato">*</span></span>
              </template>

              <validation-provider
                #default="{ errors }"
                name="year_called_into_ministry"
                rules="required"
              >
                <input
                  id="year_called_into_ministry"
                  v-model="member_profile.year_called_into_ministry"
                  placeholder="Enter year Here"
                  class="form-control"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <div v-if="member_profile.country === 'Ghana'">
              <b-form-group label="Region" label-for="region">
                <template #label>
                  <span>Region<span style="color: tomato">*</span></span>
                </template>

                <validation-provider
                  #default="{ errors }"
                  name="region"
                  rules="required"
                >
                  <v-select
                    id="region"
                    v-model="member_profile.region_id"
                    :loading="loading"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="regionOptions"
                    :reduce="(val) => val.value"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label="Area" label-for="area">
                <template #label>
                  <span>Area<span style="color: tomato">*</span></span>
                </template>

                <validation-provider
                  #default="{ errors }"
                  name="area"
                  rules="required"
                >
                  <v-select
                    id="area"
                    v-model="member_profile.area_id"
                    :loading="loading"
                    :clearable="false"
                    :options="areaOptions"
                    :reduce="(val) => val.value"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label="District" label-for="district">
                <template #label>
                  <span>District<span style="color: tomato">*</span></span>
                </template>

                <validation-provider
                  #default="{ errors }"
                  name="district"
                  rules="required"
                >
                  <v-select
                    id="district"
                    v-model="member_profile.district_id"
                    :loading="loading"
                    :clearable="false"
                    :options="districtOptions"
                    :reduce="(val) => val.value"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label="Assembly" label-for="assembly">
                <template #label>
                  <span>Assembly</span>
                </template>

                <validation-provider
                  #default="{ errors }"
                  name="assembly"
                  rules=""
                >
                  <v-select
                    id="assembly"
                    v-model="member_profile.assembly_id"
                    :loading="loading"
                    :clearable="false"
                    :options="assemblyOptions"
                    :reduce="(val) => val.value"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>

            <div v-else>
              <b-form-group label="Region" label-for="region">
                <validation-provider
                  #default="{ errors }"
                  name="region"
                  rules=""
                >
                  <input
                    id="region"
                    v-model="member_profile.region"
                    placeholder="Enter region name here"
                    class="form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label="Area" label-for="area">
                <validation-provider #default="{ errors }" name="area" rules="">
                  <input
                    id="area"
                    v-model="member_profile.area"
                    placeholder="Enter area name here"
                    class="form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label="District" label-for="district">
                <validation-provider
                  #default="{ errors }"
                  name="district"
                  rules=""
                >
                  <input
                    id="district"
                    v-model="member_profile.district"
                    placeholder="Enter district name here"
                    class="form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-form-group label="Assembly" label-for="assembly">
                <validation-provider
                  #default="{ errors }"
                  name="assembly"
                  rules=""
                >
                  <input
                    id="assembly"
                    v-model="member_profile.assembly"
                    placeholder="Enter assembly name here"
                    class="form-control"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </div>

            <b-row class="mt-1">
              <b-col cols="12" md="6">
                <validation-provider name="Is Tent Minister" rules="">
                  <b-form-checkbox
                    v-model="member_profile.is_tent_minister"
                    class="mb-3 mt-1"
                  >
                    Is Tent Minister
                  </b-form-checkbox>
                </validation-provider>
              </b-col>
            </b-row>

            <div>
              <b-button
                class="py-1"
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Save and Proceed
              </b-button>
            </div>

            <div class="text-center mt-2">
              <b-link @click="logout">
                <feather-icon icon="LogOutIcon" />
                Logout
              </b-link>
            </div>
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import {
  BCol,
  BRow,
  BAlert,
  BButton,
  BCard,
  BCardText,
  BCardTitle,
  BForm,
  BFormCheckbox,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BOverlay,
  BFormDatepicker,
} from "bootstrap-vue";

import vSelect from "vue-select";
import Cleave from "vue-cleave-component";

import { get, pick } from "lodash";
import { required } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { MUTATE_USER_MEMBER_PROFILE } from "@/store/config/mutation-keys";

import BottomDesign from "@/assets/svg/BottomDesign.svg";
import PasswordLock from "@/assets/svg/PasswordLock.svg";
import RegistrationMail from "@/assets/svg/RegistrationMail.svg";
import RegistrationPhone from "@/assets/svg/RegistrationPhone.svg";

import AuthWrapper from "@core/components/auth-wrapper/AuthWrapper.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

const memberTitlesAndDesignationCachedData = [];

const allowed_member_profile_fields = [
  "status",
  "member_type_id",
  "gender",
  "email",
  "member_title_id",
  "member_designation_id",
  "minister_id",
  "year_called_into_ministry",
  "country",
  "region",
  "area",
  "district",
  "assembly",
  "region_id",
  "area_id",
  "district_id",
  "assembly_id",
  "is_schooling",
  "institution",
  "schooling_start_date",
  "schooling_end_date",
  "is_tent_minister",
  "status",
  "department_id",
  "date_of_birth",
];

export default {
  components: {
    AuthWrapper,
    PasswordLock,
    RegistrationPhone,
    RegistrationMail,
    BottomDesign,
    BOverlay,
    BAlert,
    // BSV
    BCard,
    BLink,
    BCardTitle,
    BCardText,
    BForm,
    BFormSelect,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BFormFile,
    BFormDatepicker,

    vSelect,
    Cleave,

    BCol,
    BRow,
    // validations
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: false,
      errorMessage: "",

      member_profile: {
        member_type_id: "",
        member_title_id: "",
        member_designation_id: "",

        minister_id: "",
        year_called_into_ministry: "",

        date_of_birth: "",
        gender: "",
        country: "Ghana",
        region: "",
        area: "",
        district: "",
        assembly: "",
        region_id: "",
        area_id: "",
        district_id: "",
        assembly_id: "",
        department_id: "",

        is_tent_minister: false,
        is_schooling: false,
        institution: "",
        schooling_start_date: "false",
        schooling_end_date: "",
      },

      genderOptions: [
        {
          value: "female",
          label: "Female",
        },
        {
          value: "male",
          label: "Male",
        },
      ],

      areaOptions: [],
      regionOptions: [],
      countryOptions: [],
      districtOptions: [],
      assemblyOptions: [],

      memberTypeOptions: [],
      memberTitleOptions: [],
      memberDesignationOptions: [],
      departmentOptions: [],

      // validation rules
      required,

      cleaveDateOptions: {
        date: true,
        raw: true,
        delimiter: "-",
        datePattern: ["Y", "m", "d"],
        blocks: [4, 2, 2],
      },
      original_member_profile: {},
    };
  },
  computed: {
    isCopMinister() {
      const target = this.memberTypeOptions.find(
        (option) => option.value === this.member_profile.member_type_id
      );
      
      if (target) {
        return target.is_cop_minister
      }
      
      return false
    },
    isCopStaff() {
      const target = this.memberTypeOptions.find(
        (option) => option.value === this.member_profile.member_type_id
      );
      if (target) {
        return target.is_cop_staff
      }

      return false
    },
  },
  watch: {
    "member_profile.region_id": {
      handler(changed) {
        if (changed) {
          if (this.member_profile.country !== "Ghana") {
            return;
          }
          this.fetchChurchAreas();
        }
      },
      immediate: false,
    },
    "member_profile.area_id": {
      handler(changed) {
        if (changed) {
          if (this.member_profile.country !== "Ghana") {
            return;
          }
          this.fetchChurchDistrict();
        }
      },
      immediate: false,
    },
    "member_profile.district_id": {
      handler(changed) {
        if (changed) {
          if (this.member_profile.country !== "Ghana") {
            return;
          }
          this.fetchChurchAssemblies();
        }
      },
      immediate: false,
    },
    "member_profile.member_type_id": {
      handler(val) {
        val && this.fetchMemberTitlesAndDesignations();
      },
    },
  },
  created() {
    this.fetchChurchRegions();
    this.fetchCountries();
    this.fetchMemberTypes();
    this.fetchDepartments();
    this.fetchProfile();
  },
  methods: {
    async fetchChurchRegions() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoRegions();
        const { data } = request.data;
        this.regionOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));

        this.region_id = "";
        this.area_id = "";
        this.district_id = "";
        this.assembly_id = "";
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAreas() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoAreas(
          { region_id: this.member_profile.region_id }
        );
        const { data } = request.data;
        this.areaOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));

        if (this.hasChanged("region")) {
          this.member_profile.area_id = "";
          this.member_profile.district_id = "";
          this.member_profile.assembly_id = "";
        }
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchDistrict() {
      try {
        this.loading = true;

        const request = await this.useJwt().sharedService.fetchGeoDistricts(
          { area_id: this.member_profile.area_id }
        );
        const { data } = request.data;
        this.districtOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));

        if (this.hasChanged("area")) {
          this.member_profile.district_id = "";
          this.member_profile.assembly_id = "";
        }
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchChurchAssemblies() {
      try {
        this.loading = true;
        const request = await this.useJwt().sharedService.fetchGeoAssemblies(
          { district_id: this.member_profile.district_id }
        );
        const { data } = request.data;
        this.assemblyOptions = data.map((opt) => ({
          label: opt.title,
          value: opt._id,
        }));

        if (this.hasChanged("district")) {
          this.member_profile.assembly_id = "";
        }
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchCountries() {
      try {
        const response = await this.useJwt().sharedService.fetchCountries();

        const countries = get(response, "data.data");
        this.countryOptions = countries.map((country) => ({
          label: country.country,
          value: country.country,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async fetchMemberTypes() {
      try {
        const response = await this.useJwt().sharedService.fetchMemberTypes();

        const member_types = get(response, "data");

        this.memberTypeOptions = member_types.map((member_type) => ({
          value: member_type._id,
          label: member_type.title,
          is_cop_minister: member_type.is_cop_minister,
          is_cop_staff: member_type.is_cop_staff,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async fetchDepartments() {
      try {
        const response = await this.useJwt().sharedService.fetchDepartments();

        const departments = get(response, "data");

        this.departmentOptions = departments.map((department) => ({
          value: department._id,
          label: department.title,
        }));
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async fetchMemberTitlesAndDesignations() {
      try {
        const query = {
          member_type_id: this.member_profile.member_type_id,
        };
        const member_titles_resp =
          await this.useJwt().sharedService.fetchMemberTitles(query);
        const member_designations_resp =
          await this.useJwt().sharedService.fetchMemberDesignations(query);

        const member_titles = get(member_titles_resp, "data", []);
        const member_designations = get(member_designations_resp, "data", []);

        this.memberTitleOptions = member_titles.map((member_type_title) => ({
          value: member_type_title._id,
          label: member_type_title.title,
        }));

        this.memberDesignationOptions = member_designations.map(
          (member_designation) => ({
            value: member_designation._id,
            label: member_designation.designation,
          })
        );

        memberTitlesAndDesignationCachedData.push({
          id: this.member_profile.member_type_id,
          titles: this.memberTitleOptions,
          designations: this.memberDesignationOptions,
        });
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        console.log("error_message", error_message);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      }
    },
    async updateMemberProfile() {
      try {
        this.loading = true;
        this.errorMessage = "";

        const success = await this.$refs.registerForm.validate();
        if (!success) {
          return;
        }

        const formData = new FormData();
        Object.entries(this.member_profile).forEach(([key, value]) => {
          value && formData.append(key, value);
        });

        const response = await this.useJwt().mainService.auth.updateProfile(
          formData
        );

        const member_profile = this.getValueFromSource(response, "data.data");
        this.$store.commit(
          `auth/${MUTATE_USER_MEMBER_PROFILE}`,
          member_profile
        );
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchProfile() {
      try {
        this.loading = true;

        const response = await this.useJwt().mainService.auth.getProfile();

        const member_profile = this.getValueFromSource(response, "data.data");
        this.$store.commit(
          `auth/${MUTATE_USER_MEMBER_PROFILE}`,
          member_profile
        );

        const update_fields = pick(
          member_profile,
          allowed_member_profile_fields
        );
        this.original_member_profile = { ...update_fields };
        this.member_profile = { ...update_fields };
      } catch (error) {
        const error_message =
          get(error, "response.data.message") || error.message;
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error!",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error_message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
    hasChanged(key) {
      const original = this.getValueFromSource(
        this.original_member_profile,
        key
      );
      const update = this.getValueFromSource(this.member_profile, key);
      return original !== update;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
